const LAYOUTS = {
  DECK: "deck",
  EDIT: "edit",
  STATS: "stats",
} as const;

export default LAYOUTS;
